/* eslint-disable max-len */
/* istanbul ignore file */
export default {
  FEATURE_SURAKSHA_KAVACH_ENABLED: false,
  FEATURE_MANDATE_PROFILE: false,
  FEATURE_SHOW_PROFILE: true,
  app_id: 'covid19aicoe',
  language: 'English',
  localisation_strings: {
    Gender: {
      male: 'Male',
      female: 'Female',
      other: 'Other'
    },
    Relation: {
      father: 'Father',
      mother: 'Mother',
      brother: 'Brother',
      sister: 'Sister',
      spouse: 'Spouse',
      son: 'Son',
      daughter: 'Daughter',
      grandfather: 'Grandfather',
      grandmother: 'Grandmother',
      uncle: 'Uncle',
      aunt: 'Aunt'
    },
    APP_NAME: 'COVID-19',
    BUTTON_STATISTICS: 'Statistics',
    BUTTON_SYMPTOM_TRACKER: 'Symptom Tracker',
    BUTTON_TESTING_CENTRES: 'Testing Centres',
    BUTTON_FAQS: 'Frequently Asked Questions',
    COVID_CREATE_MEMBER_PROFILE_HEADER: 'Family member profile',
    COVID_CREATE_FATHER_PROFILE_HEADER: 'My father\'s profile',
    COVID_CREATE_MOTHER_PROFILE_HEADER: 'My mother\'s profile',
    COVID_CREATE_BROTHER_PROFILE_HEADER: 'My brother\'s profile',
    COVID_CREATE_SISTER_PROFILE_HEADER: 'My sister\'s profile',
    COVID_CREATE_SPOUSE_PROFILE_HEADER: 'My spouse\'s profile',
    COVID_CREATE_SON_PROFILE_HEADER: 'My son\'s profile',
    COVID_CREATE_DAUGHTER_PROFILE_HEADER: 'My daughter\'s profile',
    COVID_CREATE_GRANDFATHER_PROFILE_HEADER: 'My grandfather\'s profile',
    COVID_CREATE_GRANDMOTHER_PROFILE_HEADER: 'My grandmother\'s profile',
    COVID_CREATE_UNCLE_PROFILE_HEADER: 'My uncle\'s profile',
    COVID_CREATE_AUNT_PROFILE_HEADER: 'My aunt\'s profile',
    COVID_CREATE_MEMBER_PROFILE_SUBHEADER: 'Please create a small profile to keep track of your family member’s symptoms and health status',
    COVID_CREATE_PROFILE_TITLE: 'Create your health profile',
    COVID_CREATE_PROFILE_SUBTEXT: 'Create profile for you and your family and stay updated on your symptoms',
    COVID_CREATE_PROFILE_TEXT: 'Stay on top of your health status with Reliance Foundation COVID-19 tool.',
    COVID_CREATE_PROFILE_HEADER: 'My health profile',
    COVID_CREATE_PROFILE_SUBHEADER: 'Please create a small profile to keep track of your symptoms and health status',
    CREATE_PROFILE_NAME_PLACEHOLDER: 'Name',
    CREATE_PROFILE_AGE_PLACEHOLDER: 'Age',
    CREATE_PROFILE_GENDER_PLACEHOLDER: 'Gender',
    CREATE_PROFILE_RELATION_PLACEHOLDER: 'Relation',
    CREATE_PROFILE_RELATION_SAME_ADDRESS: 'Same as my location',
    CREATE_PROFILE_LOCATION_PLACEHOLDER: 'Location',
    CREATE_PROFILE_ADDR_1: 'House Number',
    CREATE_PROFILE_CONTACT_NUMBER_PLACEHOLDER: 'Mobile number',
    START_NOW: 'Start now',
    PROCEED: 'Proceed',
    CREATE_PROFILE_ERROR_MESSAGE_INPUTS: 'Please fill all mandatory fields in correct format',
    CREATE_PROFILE_ERROR_MESSAGE: 'Failed to create profile, please retry',
    FETCH_PROFILE_ERROR_MESSAGE: 'Failed to fetch family members',
    UPDATE_PROFILE_ERROR_MESSAGE: 'Failed to update profile, please retry',
    RETRY: 'Retry',
    CANCEL: 'Cancel',
    RETRY_TEXT: 'Oops! Something went wrong. Please try again later',
    FAILURE_PROFILE_TEXT: 'Oops! Something went wrong. You can view added family members in your profile section',
    UPDATE_PROFILE_SUCCESS_MESSAGE: 'Profile changes saved successfully',
    COVID_CREATE_PROFILE_BUTTON: 'Create profile',
    COVID_CREATE_MEMBER_PROFILE_BUTTON: 'Add profile',
    COVID_EDIT_MEMBER_PROFILE_BUTTON: 'Save changes',
    COVID_HOMEPAGE_DESCRIPTION: 'Coronavirus disease (COVID-19) is an infectious disease caused by a new virus that had not been previously identified in humans. Please use the below options to learn more about the disease and keep yourself updated.',
    SYMPTOM_CHECKER_TITLE: 'Symptom Checker',
    SYMPTOM_CHECKER_SUBTITLE: 'Checks for COVID-19 symptoms and pertinent risk factors',
    TESTING_CENTRE_TITLE: 'Test Centres',
    TESTING_CENTRE_SUBTITLE: 'Testing centres across India for COVID-19',
    STATISTICS_TITLE: 'Statistics',
    STATISTICS_SUBTITLE: 'National and World statistics for COVID-19',
    FAQ_TITLE: 'FAQ',
    FAQ_SUBTITLE: 'Provides answers to common questions about COVID-19',
    HELPLINE_TITLE: 'Helpline',
    HELPLINE_SUBTITLE: 'National and State Helpline numbers',
    QUESTION_ANSWERING_ADVISE: 'Please answer the question to the best of your knowledge',
    RISK_ADVISORY_DISCLAIMER: '*This is based on current understanding of the disease which is subject to change. Please do consult the doctor and take their advice in case you are not feeling well.',
    RISK_TITLE: 'Risk of Covid-19*:',
    RECOMMENDATION: 'Recommendation',
    ICMR_9TH_MARCH_GUIDELINE: 'ICMR Guidelines on testing strategy (09.03.2020)',
    ICMR_20TH_MARCH_GUIDELINE: 'ICMR Guidelines on revised testing strategy (20.03.2020)',
    ICMR_9TH_APRIL_GUIDELINE: 'ICMR Guidelines on revised testing strategy (09.04.2020)',
    YOUR_RESPONSES: 'Your Responses',
    ACTIVE_CASES: 'Active cases',
    SOURCE: 'Source',
    TOTAL_CONFIRMED_CASES: 'Total Confirmed Cases',
    DEATHS: 'Deaths',
    CURED: 'Cured',
    RECOVERED: 'Recovered',
    INDIAN_HELPLINE: 'Indian Helpline:',
    STATISTICS_UPDATED_ON: 'Updated on',
    GOVT_PROVIDED_NUMBERS: 'Indian government and Ministry of Health & Family Welfare has provided the following helpline numbers of States.',
    NATIONAL_HELPLINE_NUMBER: 'National Helpline Number:',
    CENTRAL_HELPLINE_NUMBER: 'Central Helpline Number:',
    MYGOV_WHATSAPP: 'MyGov WhatsApp Number:',
    CENTRAL_HELPLINE_EMAIL: 'Central Helpline Email:',
    CENTRAL_HELPLINE_EMAIL_ID: 'ncov2019@gmail.com',
    LAST_UPDATED_AT: 'Last Updated at',
    ICMR: 'ICMR',
    VIEW_MAP: 'View Map',
    INDIA: 'India',
    WORLD: 'World',
    CONTRIBUTED_BY: 'Contributed by',
    DR_CHETAN_BHATT: 'Dr. Chetan Bhatt (MD General Medicine, DNB Gastroenterology)',
    DR_AMRITA_VERMA: 'Dr. Amrita Verma (MD General Medicine)',
    DR_SHASHIKALA_SHIVAPRAKASH: 'Dr. Shashikala Shivaprakash (MD Microbiology)',
    STATISTICS: 'Statistics',
    HOSPITALISED: 'Hospitalized',
    ADD_PLACEHOLDER: 'House/Flat No/Sector No, Apartment Name',
    GEO_PLACEHOLDER: 'Locality, City',
    PINCODE_PLACEHOLDER: 'Pincode',
    PINCODE_ERROR: 'Please enter a valid pincode',
    LOCATION_ERROR: 'All fields are mandatory, please enter valid data',
    C_LOCATION_QUESTION: 'Please enter your exact current address',
    C_PROFILE_QUESTION: 'For whom are you taking this test?',
    C_LOCATION_SUB_TITLE: 'This address will be used in our Hospital Mgmt and lab collection systems and enables us to efficiently allocate and optimise the resources in our fight against covid-19. Thanks for your time.',
    MAP_HINT_TITLE: 'Please ensure that the map pin shows your home address correctly.  Adjust the pin if needed.',
    FIND_PINCODE: 'Find pincode',
    NEXT: 'NEXT',
    UPLOAD_COWIN_CERTIFICATE: 'Upload CoWin certificate',
    LANGUAGE_TITLE: 'Select your language',
    WORKFLOW_ID_MISMATCH: 'The covid-19 risk survey questionnaire has changed. Please retake the survey on the ESS Covid-19 symptom checker portal by clicking on the “click here” button.',
    NO_CHANGE_UNABLE_TO_CLOSE: 'Thank you for submitting survey.',
    CLICK_HERE_TO_COMPLETE: 'Click here to complete',
    PROFILE_SUCCESSFULLY_ADDED_TITLE: 'Profile created successfully!',
    PROFILE_SUCCESSFULLY_ADDED_SUBTITLE: 'Your profile has been successfully added.',
    CHECK_SYMPTOMS: 'Check symptoms',
    ADD_FAMILY_TITLE: 'Add family in your profile',
    ADD_FAMILY_SUBTITLE: 'For tracking your family health data, please create your family profile.',
    ADD_MEMBER_PROFILE: 'Add family member',
    CREATE_NOW: 'Create now',
    ADDED_FAMILY_MEMBERS: 'Added family Members',
    DONE: 'Done',
    SUBMIT: 'Submit',
    ADD_PROFILE: 'Add profile',
    SURAKSHA_KAVACH_TITLE: 'Jio Suraksha Kavach',
    SURAKSHA_KAVACH_DESCRIPTION: 'Worried your symptoms maybe COVID -19? Opt-in to Jio Suraksha Kavach!',
    TELE_CONSULTATION_TITLE: 'Tele-consultation services with doctor',
    TEST_CENTER_TITLE: 'Test centres across the country',
    COLLECT_SAMPLE_TITLE: 'Agent to collect samples for COVID tests',
    REPORT_AND_STEPS_TITLE: 'Reports and next steps',
    GET_IT_NOW: 'Get it now',
    GET_ACCESS_TITLE: 'Get access to',
    JIO_KAVACH_ACTIVATED_TITLE: 'Jio Suraksha Kavach activated for your profile!',
    VIEW_NEXT_STEPS: 'View next steps',
    NEXTSTEP_TITLE: 'Tele-consultations On JioHealthHub',
    NEXTSTEP_DESCRIPTION: 'A doctor will reach out to you for tele-consultation.',
    STEPS_FOR_TELECON: 'Steps for tele-consultantation',
    TELECON_STEP_1_DISC: 'Download JioHealthHub app from Play Store or App Store',
    TELECON_STEP_2_DISC: 'Tele-consultation with doctors',
    TELECON_STEP_3_DISC: 'Visit Reliance Foundation COVID - 19 India Tool to get details of consultation and next steps.',
    TELECON_STEP_1: 'Step 1',
    TELECON_STEP_2: 'Step 2',
    TELECON_STEP_3: 'Step 3',
    DOWNLOAD_NOW: 'Download now',
    JIO_HEALTH_HUB: 'JioHealthHub',
    ADDRESS_DETAILS: 'Address details',
    LOCATION: 'Location',
    HOUSE_BUILDING: 'House / Building',
    STREET_VILLAGE: 'Street / Village',
    LANDMARK_OPTIONAL: 'Landmark (Optional)',
    AREA_TEHSIL: 'Area / Tehsil',
    PIN_CODE: 'Pincode',
    CITY: 'City',
    DISTRICT: 'District',
    STATE: 'State',
    MY_FAMILY_PROFILE: 'My family profile',
    STATUS_AS_ON: 'Status as on ',
    GET_JIO_SURAKSHA_KAVACH: 'Get Jio Suraksha Kavach',
    PROTECT_YOUR_FAMILY_FRIENDS: 'Protect your family & friends',
    GET_IT: 'Get it',
    KAVACH_ACTIVATION_ERROR_MESSAGE: 'Unable to process your request. Please try again.',
    FAILED_LOCATION_FECTH: 'Failed to fetch your location, please enter your address',
    RECOMMENDATION_1: 'Stay home, maintain minimum 6 feet distance and avoid contact with others.',
    RECOMMENDATION_2: 'Practice personal hygiene as a preventive measure.',
    RECOMMENDATION_3: 'Avoid any travel unless absolutely necessary.',
    SETUP_NOW: 'Setup Now',
    REPORT_HISTORY: 'Report History',
    SURAKSHA_KAVACH_CARD_INFO: 'Protect your family & friends. Opt-in to avail benefits to doctors, test centres and more!',
    BOOKING_TC_TITLE: 'Tele - consultations services  with doctor',
    BOOKING_TC_DESC: 'A doctor will reach out to you for tele-consultation',
    BOOKING_VT_TITLE: 'Select date and time slot for sample submission',
    BOOKING_VT_DESC: '',
    BOOKING_SC_TITLE: 'Sample collection',
    BOOKING_SC_DESC: 'Our agent will come to collect sample for testing',
    BOOKING_DATE_TITLE: 'Book appointment date and time',
    BOOKING_TIME_TITLE: 'Select time slot',
    APPOINTMENT_BOOKED_S: 'Appointment booked successfully',
    APPOINTMENT_BOOKED_F: 'Could not book appointment please try again',
    BOOKING_DATE_WARNING: 'Please select an appropriate date',
    BOOKING_TIME_WARNING: 'Please select an appropriate time slot',
    TIME_SLOT_ERROR_TEXT: 'Oops! Something went wrong',
    TIME_SLOT_ERROR_SUBTEXT: 'Sorry we are unable to fetch time slots at this moment! Please try again later.',
    APPOINTMENT_ID: 'Appointment ID',
    VISIT_TEST_CENTER: 'Visit test center',
    YOU_WILL_NEED_TO_VISIT: 'You will need to visit a test center and submit sample for testing.',
    CHOOSE_FROM_TEST_CENTER: 'Choose from below test centres',
    ADDRESS: 'Address',
    BOOK_APPOINTMENT: 'Book appointment',
    STATUS_PAGE_BOTTOM_TEXT: 'Show the QR code in test center. You can also find your appointment details in profile section. We will reach out to you for more details.',
    TELE_CON_STATUS_TEXT: 'You can also find your appointment details in profile section. We will reach out to you for more details.',
    APPOINTMENT_QR_CODE: 'Appointment QR code',
    APPOINTMENT_DATE: 'Appointment date',
    APPOINTMENT_TIME: 'Appointment Time',
    APT_TEST_CENTER_ADDR: 'Test center Address',
    MY_APPOINTMENT_ID: 'My Appointment ID',
    APPOINTMENT_MSG: 'Appointment booked Successfully!!!!',
    WILL_REACH_OUT: 'We will reach out to you soon with Test Centre and time slot details',
    APPOINTMENT_ID_AVAILABLE: 'Appointment ID will be available in your profile section',
    REFRESH_STATUS: 'Refresh Status',
    GENDER_MALE: 'Male',
    GENDER_FEMALE: 'Female',
    GENDER_OTHER: 'Other',
    RELATION_FATHER: 'Father',
    RELATION_MOTHER: 'Mother',
    RELATION_BROTHER: 'Brother',
    RELATION_SISTER: 'Sister',
    RELATION_SPOUSE: 'Spouse',
    RELATION_SON: 'Son',
    RELATION_DAUGHTER: 'Daughter',
    RELATION_GRANDFATHER: 'Grandfather',
    RELATION_GRANDMOTHER: 'Grandmother',
    RELATION_GRANDSON: 'Grandson',
    RELATION_GRANDDAUGHTER: 'Granddaughter',
    RELATION_UNCLE: 'Uncle',
    RELATION_AUNT: 'Aunt',
    RELATION_SELF: 'Self',
    RELATION_FATHERINLAW: 'Father in law',
    RELATION_MOTHERINLAW: 'Mother in law',
    RISK: 'Risk',
    ESSENTIAL_SERVICES_RISK: 'Essential Services Risk',
    ESSENTIAL_SERVICES_LOW_RISK: 'Essential Services Low Risk',
    HIGH_RISK_V2: ' High Risk v2 (with symptoms)',
    HIGH_RISK: 'High Risk(without symptoms)',
    MEDIUM_RISK: ' Medium Risk',
    LOW_RISK: 'Low Risk',
    COVID_19: 'COVID 19',
    BUTTON_HOME: 'Home',
    BUTTON_PROFILE: 'Profile',
    ADDRESS_LINE_1: 'Flat / House No. / Floor / Building',
    ADDRESS_LINE_2: 'Colony / Street / Locality',
    CREATE_PROFILE_RELATION_SAME_NUMBER: 'Same as my mobile number',
    MY_FAMILY: 'MY FAMILY',
    OTHERS: 'OTHERS',
    SAVE_ADDRESS: 'Save Address',
    CLEAR: 'Clear',
    EDIT_PROFILE: 'Edit Profile',
    TAKE_SURVEY: 'Take Survey',
    YEARS: 'years',
    YEAR: 'year',
    MONTHS: 'months',
    MONTH: 'month',
    WEEKS: 'weeks',
    WEEK: 'week',
    DAYS: 'days',
    DAY: 'day',
    HOURS: 'hours',
    HOUR: 'hour',
    MINUTES: 'minutes',
    MINUTE: 'minute',
    SECONDS: 'seconds',
    SECOND: 'second',
    AGO: 'ago',
    TERMS: 'Terms and Conditions',
    PRIVACY: 'Privacy',
    DELETE_CONFIRMATION: 'Are you sure that you want to delete?',
    UPLOAD_TITLE: 'UPLOAD',
    ADD_MORE_THAN: 'You can not add more than',
    RECORDINGS: 'recordings',
    COUGH_RECORDING: 'Cough Recordings',
    TAP_TO_START: 'Tap to start',
    TAP_TO_SUBMIT: 'Tap to Submit',
    USER_AS_SENSOR_TITLE: 'User as a Sensor',
    USER_AS_SENSOR_SUBTITLE: 'Questionnaire for User as a Sensor',
    EOI_THANK_YOU: 'Thank You.',
    EOI_THANK_YOU_COMPONENT_TEXT: 'You will be notified about the next steps in a few weeks. The roll-out and all related processes will be in accordance with Government of India guidelines.',
    EOI_THANK_YOU_COMPONENT_PROFILE_CREATION_TEXT: 'Thank you for expressing your interest in the COVID-19 vaccine and creating JioHealthHub profile.',
    EOI_THANK_YOU_COMPONENT_PROFILE_VALIDATION_TEXT: 'Thank you for expressing your interest in the COVID-19 vaccine and validating JioHealthHub profile.',
    EOI_THANK_YOU_COMPONENT_WHATSAPP_NOTIFICATION_TEXT: 'You will also be notified about vaccine availability on WhatsApp.',
    EOI_CANCEL_TEXT: 'Are you sure you want to cancel the process?',
    EOI_ENTER_OTP_TEXT: 'Enter and verify OTP',
    EOI_RESEND_OTP_TEXT: 'OTP is valid for 10 minutes. You can resend OTP in',
    EOI_GET_OTP: 'Get OTP',
    EOI_RESEND_OTP: 'Resend OTP',
    EOI_CANCEL: 'Cancel',
    EOI_PROCEED: 'Proceed',
    EOI_DONE: 'Done',
    EOI_USE_DIFFERENT_JIOHEALTHHUB_ID: 'Use different JioHealthHub ID',
    EOI_USE_DIFFERENT_JIOHEALTHHUB_ID_PLEASE_PROVIDE: 'Please provide the JioHealthHub ID for ',
    EOI_USE_DIFFERENT_JIOHEALTHHUB_ID_PLEASE_ENSURE: '. Please ensure the JioHealthHub ID belongs to ',
    EOI_USE_DIFFERENT_JIOHEALTHHUB_ID_ASSOCIATION_WARNING: '. JioHealthHub ID association cannot be changed once verification is done.',
    EOI_CREATE_NEW_JIOHEALTHUB_ID: 'Create new JioHealthHub ID',
    EOI_CREATE_NEW_JIOHEALTHUB_ID_TEXT: 'Please validate your details.',
    EOI_USE_EXISTING_CORPORATE_PROFILE_LINK: 'Use existing corporate profile',
    EOI_USE_EXISTING_FAMILY_PROFILE_LINK: 'Use existing family profile',
    EOI_CREATE_NEW_JIOHEALTHHUB_ID_LINK: 'Create new JioHealthHub ID',
    EOI_USE_DIFFERENT_JIOHEALTHHUB_ID_LINK: 'Use different JioHealthHub ID',
    EOI_JIOHEALTHHUB_ID: 'JioHealthHub ID',
    EOI_NAME: 'Name',
    EOI_NAME_PLACEHOLDER: 'Enter Name',
    EOI_DATE_OF_BIRTH: 'Date of Birth',
    EOI_DATE_OF_BIRTH_PLACEHOLDER: 'Enter Date of Birth',
    EOI_PHONE_NUMBER: 'Phone Number',
    EOI_PHONE_NUMBER_PLACEHOLDER: 'Enter Phone Number',
    EOI_PHONE_NUMBER_TEXT: `JioHealthHub ID for family members will be created with employee's mobile number registered with JIoHealthHub.`,
    EOI_GENDER: 'Gender',
    EOI_MALE: 'Male',
    EOI_FEMALE: 'Female',
    EOI_SELECT_GENDER: 'Select Gender',
    EOI_PROFILE_DETAILS: 'Profile Details',
    EOI_PROFILE_DETAILS_TEXT: 'Please validate your details. You can also use a different JHH ID or create a new one. Please choose one of the following options:',
    EOI_EXISTING_USER: 'Existing User',
    EOI_CREATE_NEW: 'Create new',
    EOI_EXPRESS_INTEREST: 'Express Interest',
    EOI_EXPRESSION_OF_INTEREST: 'Vaccination Expression of Interest',
    EOI_INTEREST_EXPRESSION: 'Interest Expression',
    EOI_INTEREST_EXPRESSION_TEXT_PREVIOUS_RESPONSE_YES: `you had previously registered "Yes" as your interest for Covid-19 vaccine. Do you wish to continue with "Yes"?`,
    EOI_INTEREST_EXPRESSION_TEXT_PREVIOUS_RESPONSE_NO: 'Please submit your interest for Covid 19 vaccines for',
    EOI_TNC_TEXT: `By expressing interest,you agree to the <a target="__blank" rel="noopener noreferrer" href="https://production.healthhub.net.in/jiohealthhub/covid19_vaccine/tnc"><b><u>Terms and Conditions</u></b></a>.`,
    EOI_YES: 'Yes',
    EOI_NO: 'No',
    EOI_ALREADY_VACCINATED: 'I am already vaccinated',
    EOI_FALLBACK_ERROR_MESSAGE: 'Something went wrong. Please try again.',
    EOI_THANK_YOU_MESSAGE_END: 'You can also manage all your health records in one place.',
    EOI_THANK_YOU_MESSAGE_ALREADY_VACCINATED_1: 'Thank You. Kindly verify your JioHealthHub ID and upload your CoWin certificate',
    EOI_THANK_YOU_MESSAGE_ALREADY_VACCINATED_2: 'You can avail following services on Jiohealthhub',
    EOI_THANK_YOU_MESSAGE_YES_SELECTED: 'Thank You. You have expressed “Yes” to your interest towards Covid 19 vaccination.',
    EOI_THANK_YOU_MESSAGE_YES_SELECTED_NOTIFY_MESSAGE: 'You will be notified about the next steps in a few weeks. The roll-out and all related processes will be in accordance with Government of India guidelines.',
    EOI_THANK_YOU_MESSAGE_YES_SELECTED_JHH_VALIDATED_YES: 'Please use your Jiohealthhub profile for following services',
    EOI_THANK_YOU_MESSAGE_YES_SELECTED_JHH_VALIDATED_NO: 'Please link your Jiohealthhub profile below as it would be required for following services',
    LETS_CREATE_JHH_ID: 'Let’s confirm/create your JioHealthHub profile.',
    EOI_GHOST_ID_MESSAGE: 'In order to get timely notifications regarding Covid -19 vaccination drive for your family, please complete the flow for yourself through ESS and create/validate your JioHealthHub profile. You can also download the JiohealthHub app and complete the corporate profile linkage.',
    EOI_THANK_YOU_MESSAGE_NO_SELECTED: 'Thank You. You have expressed “No“ to your interest towards Covid 19 vaccination. You can always change your response by navigating through the Main Menu.',
    EOI_THANK_YOU_MESSAGE_LOGIN_SIGNUP: 'You can signup/login to Jiohealthhub to avail following services.',
    TIMELY_NOTIFICATIONS_COVID19_VACCINE: 'Timely notifications for Covid-19 Vaccine',
    COVID19_VACCINE_BOOKING: 'Covid-19 Vaccine Booking',
    COVID19_VACCINE_CERTIFICATE: 'Covid-19 Vaccine Certificate',
    COVID19_PASS_SERVICES: 'Covid-19 pass services',
    DOCTOR_CONSULT_SERVICES: 'Doctor Consult Services',
    MANAGING_HEALTH_RECORDS: 'Managing health records',
    VACCINATION_FAQ: 'Vaccination FAQ',
    VACCINE_NOTIFICATION_CONFIRM_ADDRESS_TEXT: 'In order to get timely notifications regarding Covid vaccine booking please ensure your current address is updated in ESS. You can update it',
    EOI_HERE: 'here.',
    EOI_GET_JHH_ID: 'How to get JioHealthhub ID',
    VACCINE_NOTIFICATION_SYMPTOM_CHECKER: 'Kindly also complete the symptom checker survey in order to capture the health status for Covid Vaccination drive. You can do it ',
    HI: 'Hi',
    VACCINATION_SYMPTOM_CHECKER_TEXT_1: 'been vaccinated for dose 1?',
    VACCINATION_SYMPTOM_CHECKER_TEXT_2: 'been vaccinated for dose 2?',
    HAVE_YOU: 'Have you',
    HAVE_YOUR: 'Have your',
    VACCINATION_CATEGORY_HEADER: 'My Vaccination Schedule and Certification',
    COWIN_CERTIFICATE_TEXT: 'My CoWIN Certificate Provided by The Government',
    RELIANCE_COVID_19_VACCINATION_TEXT: 'Reliance Covid-19 Vaccine Certificate',
    NO_CERTIFICATE_AVAILABLE: 'No certificate available',
    DROP_FILE_HERE_OR: 'DROP FILE HERE OR',
    BROWSE: 'BROWSE',
    DRAG_N_DROP_SUGGESTION: 'Drag and drop files to this area for quick upload',
    FILE_TYPE_SUGGESTIONS: 'Accepted file types: <b>JPG/JPEG/PNG & PDF</b>, file size should not be more than 10 mb',
    COWIN_CERT_UPLOAD_HEADER: 'Upload Vaccination Certificate',
    ATTACHED_FILE: 'Attached File',
    FILE_UPLOAD_DISCLAIMER: 'Please ensure you are uploading certificate for the selected user, Report upload may take some time and you will receive notification on your JioHealthHub app when the report is ready.',
    REPLACE: 'Replace',
    SUBMIT: 'Submit',
    CERTIFICATE_UPLOAD_SUCCESS: 'Certificate queued for upload, you will receive a notification on your JioHealthHub application once file is successfully uploaded in your account',
    GO_TO_DASHBOARD: 'Go to Dashboard',
    JHH_ID_NOT_VERIFIED_CERTIFICATE: 'In order to be able to upload certificate for your family, please complete the flow for yourself through ESS and create/validate your JioHealthHub profile. You can also download the JioHealthHub app and link Profile using Manage Identity feature.',
    JHH_ID_NOT_VERIFIED_SC: "To take Symptom Checker for your family member, please complete the following steps <ol><li>Go to Self Declaration Form (Symptom Checker Family Page)</><li>Click on 'Vaccine' button against Self</li><li>Verify/Create your JioHealthHub Id</li></ol>",
    JHH_ID_NOT_VERIFIED_VACCINATION_INFO: "To view vaccination details for your family member, please complete the following steps <ol><li>Go to Self Declaration Form (Symptom Checker Family Page)</><li>Click on 'Vaccine' button against Self</li><li>Verify/Create your JioHealthHub Id</li></ol>",
    JHH_ID_NOT_VERIFIED_DEFAULT: "To continue, please complete the following steps <ol><li>Go to Self Declaration Form (Symptom Checker Family Page)</><li>Click on 'Vaccine' button against Self</li><li>Verify/Create your JioHealthHub Id</li></ol>",
    EXPRESSION_OF_INTEREST: 'Expression of Interest',
    BACK_ARROW: 'back-arrow',
    PLEASE_SUBMIT_YOUR_INTEREST_FOR_COVID19_VACCINE_FOR: 'Please submit your interest for Covid-19 vaccine for',
    WHICH_LOCATION_DO_YOU_WANT_TO_BE_VACCINATED_AT: 'Which location do you want to be vaccinated at?',
    PIN_CODE: 'PIN Code',
    CITY: 'City',
    STATE: 'State',
    THANK_YOU_MESSAGE_ALREADY_VACCINATED: 'You have expressed <span class="font-black">"I am already vaccinated"</span> as your interest towards Covid-19 vaccination.',
    THANK_YOU_MESSAGE_YES_SELECTED: 'You have expressed <span class="font-black">"Yes"</span> as your interest towards Covid -19 vaccination.',
    THANK_YOU_MESSAGE_NO_SELECTED: 'You have expressed <span class="font-black">"No"</span> as your interest towards Covid-19 vaccination.You can always change your response by navigating through main menu.',
    DONE: 'Done',
    UPLOAD_CERTIFICATE_MESSAGE: 'Kindly upload your CoWin certificate',
    ARTICLES_HEADING: 'Daily Health Content on Jio Health Hub',
    ARTICLES_JIONEWS_HEADING: 'Latest Health Updates from Jionews',
    EXPLORE_NOW: 'Explore Now!',
    READ_MORE: 'Read More!',
    CLICK_TO_WATCH: 'Click to watch!',
    HEALTH_AND_FITNESS: 'Health & Fitness',
    COVID_19_UPDATES: 'Covid-19 Updates',
    DAILY_TIPS_AND_VIDEOS: 'Daily Tips & Videos',
    DISEASE_INFORMATION: 'Disease Information',

    UPLOADED_CERTI_TEXT: 'Uploaded certificate will show in your verified JioHealthHub account with name ',
    AND_JHH_ID: 'and JioHealthHub ID',
    FILE_DROP_ERROR: 'Please add single PDF/JPG/JPEG/PNG file only',
    FILE_DROP_TEXT: 'Drop the file here ...',
    VACCINATION_CERTI_ATTACH_ERROR: 'File selected does not match file type specification or size specification',
    GET_LAST_VACCINATION_DETAILS: 'Get Uploaded Certificate Details',
    STATUS: 'Status',
    UPLOADED_DATE_AND_TIME: 'Uploaded Date & Time',
    UPLOADED_VACCINE_CERTIFICATE_DETAILS: 'Uploaded Vaccine Certificate Details',
    NO_CERTIFICATE_FOUND: 'No Certificate Found',

    YES: 'Yes',
    NO: 'No',
    PROVIDE_VACCINE_DETAILS_TEXT: 'Please provide the vaccine details for dose ',
    UPLOAD_CERTIFICATE: 'Upload Certificate',
    ENTER_VACCINE_INFO: 'Enter Vaccine Info',
    NAME_OF_VACCINE_DOSE: 'Name of vaccine dose ',
    DATE_OF_VACCINE_DOSE: 'Date of vaccine dose ',
    VALIDATE_JIOHEALTHHUB_ID: 'Validate JioHealthHub ID',
    VACCINATION_QUESTION: 'vaccinated with dose',
    VACCINATION_STATUS: 'Vaccination Status',
    ARE_YOU: 'Are you',
    IS_YOUR: 'Is your',
    UPDATE_VACCINE_DETAILS_GUIDE_TEXT: 'If you have the vaccination certificate available, please upload the same by either taking a picture or uploading it as a PDF. Alternatively, you may also enter the vaccination details manually.',
    VACC_DETAILS_THANK_YOU_COMPONENT_TEXT: 'Thank you. Your details have been successfully submitted',
    VACCINATION_DETAILS: 'Vaccination Details',
    SELECT_VACCINE_NAME_ERROR: 'Please select name of vaccine',
    ENTER_VACCINE_DATE_ERROR: 'Please enter date of vaccine',
    VACCINE_DATE_FORMAT_ERROR: 'Please enter date correctly',
    SELECT: 'Select',
    VACCINATED_Q: 'Are you vaccinated with dose ',
    BOOKED_APPOINTMENT_DETAILS: 'Booked Appointment Details',
    RESCHEDULE_BUTTON: 'Reschedule',
    CANCEL_BUTTON: 'Cancel',
    PATIENT_NAME: 'Name of patient',
    APPOINTMENT_DATE_TIME: 'Appointment date & time',
    CENTER_DETAILS: 'Center Details',
    ORDER_DETAILS: 'Order ID',
    APPOINTMENT_STATUS: 'Appointment status',
    VACCINE_NAME: 'Vaccine name and dose',
    APPOINTMENT_CENTRE: 'Appointment Centre',
    NEXT_DOSE_DATE: 'Next dose due date',
    BOOKED_ORDER_DETAILS: 'Order details',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    ARE_YOU_SURE_TEXT: 'Are you sure you want to cancel this appointment?',
    NO_APPOINTMENTS_TEXT_SCHEDULED: 'You don’t have any upcoming appointments.',
    NO_APPOINTMENTS_TEXT_HISTORY: 'You have no appointment history!',
    NO_APPOINTMENTS_SUB_TEXT: 'To book an appointment, click here',
    GET_DIRECTION: 'Get Direction',
    DATE_TIME: 'Date & Time',
    CENTRE: 'Centre',
    GO_BACK: 'Go Back',
    VIEW_DETAILS: 'View details',
    BOOK_NEXT_APPOINTMENT: 'Book next appointment',
    FILTER_BY: 'Filter by',
    VACCINATION_DETAILS_FOUND: 'Please find below the latest updated vaccination details we have for you.',
    DOSE_LBL: 'Dose',
    VACC_NAME_LBL: 'Vaccine Name',
    DATE_LBL: 'Date',
    EDIT_DETAILS_LBL: 'Edit Details',
    EDIT_VACCINATION_DETAILS: 'Edit your vaccination details',
    DOSE: 'Dose',
    VACCINE_NAME: 'Vaccine Name',
    AGE_WARNING_TXT: 'We are afraid that you are not eligible for COVID-19 vaccination. As per the Government norms, people with 18 years of age and above are only eligible for COVID-19 vaccination',
    FILE_UPLOAD_SUCCESS_LBL: 'File has been uploaded successfully!',
    FILE_UPLOAD_SUCCESS_TXT: 'It may take some time for the details to be reflected here. Please check again later.',
    FILE_UPLOAD_FAILED_LBL: 'File upload failed! Please try again.',
    FILE_UPLOAD_FAILED_TXT: 'Kindly ensure that the file uploaded is not greater than 10 Mb and is one of the following supported file formats: JPG/JPEG/PNG/PDF.',
    PROCEED_BOOK_APPT: 'Please proceed to book an appointment for vaccination now.',
    PINCODE: 'Pincode',
    DETECT: 'Detect',
    SEARCH_CENTERS: 'search centers',
    CHANGE_PINCODE: 'Change Pincode',
    JHH_ID: 'JHH ID',
    ALREADY_BOOKED_APPOINTMENTS_TEXT: 'You have booked an appointment already!',
    ALREADY_BOOKED_APPOINTMENTS_SUB_TEXT: 'Please complete the first appointment before proceeding for the next.',
    VIEW_BOOK_APPOINMENT: 'View appointment details',
    NO_CENTER: 'No centres available for the selected pin code',
    SELECT_CENTERS: 'Select Centers',
    SELECT_DATE: ' Select Date/Time',
    DETAILS: 'Details',
    VACCINATED_HEADER: 'we do not have your vaccination details.',
    BOOK_APPT: 'Book appointment',
    KM: 'km',
    DOSE_AVAILABLE: 'Dose available',
    FIRST_SECOND: '1st & 2nd',
    DOSE: 'Dose-',
    PATIENT_DETAILS: 'Patient Details',
    APPOINTMENT_DETAILS: 'Appointment Details',
    CENTER: 'Center :',
    DATE_TIME: 'Date & Time :',
    ACCEPT: ' I agree to receive order updates.',
    CONFIRM: 'Confirm Booking',
    BOOKING_DETAILS: 'Booking Details',
    FAILED: 'Failed!',
    SUCCESS: 'Booked Successfully!',
    FAIL_SUB: 'Your appointment has not been booked due to some error.',
    SUCCESS_SUB: 'Your booking has been completed successfully',
    TRY_AGAIN: 'Try Again',
    MY_APPOINTMENTS: 'Go to My Appointments',
    SHARE: 'Share',
    BOOKING_QR_TEXT: 'Booking confirmation QR code',
    BOOKING_QR_TEXT_MOBILE: 'Booking confirmation QR code of',
    TRY_AGAIN_TEXT: 'Try again',
    BOOK_ERROR_TEXT: 'We are unable to proceed with your current request. Please try again later.',
    AGE_GROUP_LABEL: 'Available for age group',
    CENTER_DETAILS_CALL_LABEL: 'Call to center for details',
    SELECT_DATE_TIME: 'Select appointment date & time',
    SLOTS: 'Slots',
    NO_SLOTS_AVAILABLE: 'No slots available for this date',
    SLOTS_AVAILABLE: 'slots available',
    CHANGE: 'Change',
    DOWNLOAD: 'Download',
    INSTRUCTIONS: 'Instructions',
    INST_0: 'Go to the CoWin registration link ',
    INST_0_LINK: 'www.cowin.gov.in',
    INST_1: 'Click on “Register/ Sign In yourself”',
    INST_2: 'Enter your mobile number and click on ‘Get OTP’',
    INST_3: 'Enter the OTP',
    INST_4: 'Once a new window opens, note down the 14 digits REF ID',
    INST_5: 'Use REF ID and Mobile number to go ahead with Vaccination booking on JioHealthHub app',
    COWIN_HEADER: 'Already registered on Co-WIN portal?',
    COWIN_SUB_HEADER: 'Please provide the Co-WIN registration details used to register this user.',
    COWIN_NOT_REGISTERED: 'If not registered on Co-WIN portal',
    COWIN_NOT_REGISTERED_TEXT: 'According to Government of India (GOI) norms Co-WIN registration is mandatory before vaccination. ',
    COWIN_REGISTER_LBL: 'Register at Co-WIN portal',
    COWIN_CLICK_HERE: 'Click here',
    FOR_INSTRUCTION: ' for instruction',
    REFER_HERE: 'Refer here',
    REFER_NEXT: ' for details.',
    CONFIRM_REF_ID: 'Confirm reference ID',
    REFERENCE_ID: 'Enter reference ID',
    ERROR_MSG: 'We are unable to proceed with your current request, Please try again later',
    EDIT_COWIN_DETAILS: "Edit Cowin Details",
    COWIN_NAME: "Co-WIN Name",
    COWIN_MOBILE: "Co-WIN Mobile",
    COWIN_REF_ID: "Co-WIN Reference Id",
    SAVE: "Save",
    SHOW_QR_CODE: "Show QR code",
    QR_CODE: "QR code",
    NAME: "Name",
    GENDER: "Gender",
    MOBILE: "Mobile",
    DATE_OF_BIRTH: "Date of Birth",
    APPOINTMENT_ID: "Appointment Id",
    ENTER_NAME_ERROR: "Please enter valid name",
    ENTER_MOBILE_ERROR: "Please enter valid mobile no",
    ENTER_REFID_ERROR: "Enter reference id",
    BOOKED_DATE: "Booked date",
    AGE: "Age",
    SEARCH_BY_PINCODE: 'SEARCH BY PINCODE',
    SEARCH_BY_DISTRICT: 'SEARCH BY DISTRICT',
    ENTER_PINCODE: 'Enter pincode',
    SEARCH: 'Search',
    VACCINE_FINDER: 'Vaccine Finder',
    NO_SLOT_AREA: 'No slots available in this area. Please check with a different pincode or a district',
    NO_SLOT_DATE: 'No slots available for this date. Please check availability for a different date',
    ERROR_SLOT: 'We are unable to process your request. Please try again after some time.',
    VIEW_DATE: 'View all dates',
    SLOTS: 'SLOTS',
    BOOK_COWIN: 'Book on Co-WIN',
    ERROR_PINCODE_EMPTY: 'Please enter pincode',
    ERROR_PINCODE_INVALID: 'Please enter a 6-digit valid pincode',
    ERROR_DISTRICT: 'Please select district',
    ERROR_STATE: 'Please select state',
    PREPAID_VACCINE_ERROR_TEXT: 'You are eligible for paid vaccine. Please continue your bookings on JioHealthHub website',
    VACCINATION_TITLE: "Covid-19 Vaccine",
    VACCINATION_SUBTITLE: "Book and manage Covid-19 vaccination for your loved ones",
    HEALTHPATRI_TITLE: "Health Patri",
    HEALTHPATRI_SUBTITLE: "Track Vitals, Manage Health, View Health Articles and more",
    VACCINATION_PORTAL_ACCESS_MESSAGE: "You can now book vaccinations by clicking the 'Vaccine' button in ESS.",
    CONSULTATION_TITLE: "Consult Doctor Online",
    CONSULTATION_SUBTITLE: "Connect with doctors from home",
    CONSULTATION_NEAR_ME_TITLE: "Find Doctor Near Me",
    CONSULTATION_NEAR_ME_SUBTITLE: "Find experts and book appointment slots for doctors near you",
    NATIONAL_HEALTH_ID: "National Health ID",
    NATIONAL_HEALTH_ID_DESCRIPTION: "Create/Associate ABDM Health ID",
    MANAGED_HEALTH_TITLE: "Managed Health",
    MANAGED_HEALTH_SUBTITLE: "Curated care plan for you and family",
    HEALTH_LOCKER_TITLE: "Health Locker",
    HEALTH_LOCKER_SUBTITLE: "Manage & share health reports",
    SELF_CHECKER_TITLE: "Self-Health Check",
    SELF_CHECKER_SUBTITLE: "Stay healthy by checking your risk-level for health conditions",
    AI_SYMPTOM_CHECKER_TITLE: "AI Symptom checker",
    AI_SYMPTOM_CHECKER_SUBTITLE: "Assess your symptoms and Identify possible health conditions",
  }
}
